import { useMemo } from 'react';
import { first } from 'lodash';

import { Navigate } from '../../utilities/PgmUtilities';
import { useMenu } from '../../stores/DashboardMenuStore';
import { useGroupPages, useLandingPage } from '../../stores/SessionStore';

export function useDefaultPage() {
    const [dashboardMenu] = useMenu();
    const [landingPage] = useLandingPage();
    const [visiblePages] = useGroupPages();

    return useMemo(() => {
        const dashboard = first(dashboardMenu?.userDashboards);
        const systemDefaultPage = dashboard ? dashboard.id : first(visiblePages);
        // Pre-group functionality routed user to the first dashboard they had access to if one exists. With groups
        // we want to prefer their landing page, and the fall back on the previous default of the first dashboard.
        // This fallback will occur anytime a user does not have a group, or anytime they in the default group.
        let defaultPage;
        if (visiblePages?.length || dashboardMenu?.sharedDashboards?.length) {
            defaultPage = landingPage ? `/${landingPage}` : `/${systemDefaultPage}`;
        } else {
            defaultPage = '/no-access';
        }

        return { defaultPage, systemDefaultPage };
    }, [dashboardMenu, landingPage, visiblePages]);
}

export default function DefaultPage({ replace = false }) {
    const { defaultPage } = useDefaultPage();

    return <Navigate to={defaultPage} replace={replace} />;
}
